import { Component, Input } from '@angular/core';

@Component({
  selector: 'mt-container',
  templateUrl: './mt-container.component.html',
  styleUrls: ['./mt-container.component.scss']
})
export class MtContainerComponent {

  @Input() public title: string;

  @Input() public subtitle: string;

  constructor() { }
}
